import { render, staticRenderFns } from "./EditCommissionsSettingsModal.vue?vue&type=template&id=1f69937b&scoped=true&"
import script from "./EditCommissionsSettingsModal.vue?vue&type=script&lang=ts&"
export * from "./EditCommissionsSettingsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f69937b",
  null
  
)

export default component.exports